import React from 'react';
import styled from 'styled-components';

import Button from '@catalogo/ui-americanas-desktop-button';

import QuestionBox from './question-box';

export const LastQuestions = ({
  titleCustomerQuestions,
  customerQuestions,
  productId,
  hasQuestions,
  hasCustomerQuestions,
  hasOffers,
}) => {
  if (!hasCustomerQuestions) {
    return null;
  }

  const renderHeader = () => (
    <WrapperHeader>
      <Title>{titleCustomerQuestions}</Title>
      {hasOffers && hasQuestions && (
        <WrapperButton>
          <ButtonUI
            href={`/perguntar/${productId}`}
            width="200px"
            height="45px"
            title="Escrever pergunta"
            borderRadius="8px"
            fontSize="16px"
          />
        </WrapperButton>
      )}
    </WrapperHeader>
  );

  return (
    <Wrapper>
      {renderHeader()}
      {customerQuestions.map(question => (
        <QuestionBox key={question.owner.id + Math.random()} question={question} />
      ))}
    </Wrapper>
  );
};

export default LastQuestions;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background-color: #fff;
`;

const Title = styled.p`
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSize.lg};
`;

const WrapperHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const WrapperButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

const ButtonUI = styled(Button)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;
